import { useEffect, useSyncExternalStore } from "react";
import {
  getCart,
  hydrateCartFromStorage,
  subscribeCart,
  watchCartStorage,
  type CartItem,
} from "@/lib/cart";

const emptyState = { items: [] as CartItem[], discountCode: undefined as string | undefined };

export function useCart() {
  const cart = useSyncExternalStore(subscribeCart, () => getCart(), () => emptyState);

  useEffect(() => {
    hydrateCartFromStorage();
    return watchCartStorage();
  }, []);

  return cart;
}
